import { Component } from '@angular/core';
import { InactivityService } from './core/services/inactivity.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Avery Cloud';

  // Injecting InactivityService here ensures it is instantiated at app startup so its
  // route-change subscription starts/stops the idle timer (Atenza parity).
  constructor(private inactivityService: InactivityService) {}
}
